export const UserRole = {
  Owner: 'owner',
  Admin: 'admin',
  Creator: 'creator',
  Viewer: 'viewer',
  Client: 'client',
} as const;

export type UserRoleType = (typeof UserRole)[keyof typeof UserRole];

export function ConvertWorkspaceUserRole(role: UserRoleType): number {
  switch (role) {
    case 'owner':
      return 0;
    case 'admin':
      return 1;
    case 'creator':
      return 2;
    case 'viewer':
      return 3;
    case 'client':
      return 4;
  }
}
